import {ChangeDetectionStrategy, Component, Input, OnChanges, OnInit, SimpleChanges} from "@angular/core";
import * as _ from "lodash";

@Component({
  standalone: false,
  selector: 'app-service-package-volume',
  templateUrl: './service-package-volume.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ServicePackageVolumeComponent implements OnInit, OnChanges {
  @Input() items: any;

  public totalVolume: any;

  ngOnInit() {
    this.initTotalVolume();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.items && !changes.items.isFirstChange()) {
      this.initTotalVolume();
    }
  }

  private initTotalVolume() {
    this.totalVolume = this.items.reduce((acc, i) => {
      return acc + _.get(i, 'dimensions.cube', 0)
    }, 0);
  }
}
